import Breadcrumbs from 'shared/ui/Breadcrumbs'
import { PATHS } from 'shared/utils/paths'

import { SectionContainer } from '../landings/styles'

const HowToRegisterBreadcrumbs = () => {
  return (
    <SectionContainer as='div'>
      <Breadcrumbs
        breadcrumbs={[
          { label: 'Strona główna', path: PATHS.home },
          { label: 'Jak założyć konto?', path: PATHS.howToRegister }
        ]}
      />
    </SectionContainer>
  )
}

export default HowToRegisterBreadcrumbs
